module.exports = __webpack_public_path__ + "static/about_us-00ec4614eaa6288398210afee8fd3ad7.jpeg";